import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface ExternalPortalState {
	/** When true, show alternate chrome (e.g. minimal header) for embedded launches. */
	embedAlternateChrome: boolean;
	/** Internal path+search+hash to open after sign-in when the session started with `?source=wp`. */
	postLoginPath: string | null;
}

const initialState: ExternalPortalState = {
	embedAlternateChrome: false,
	postLoginPath: null,
};

const externalPortalSlice = createSlice({
	name: "externalPortal",
	initialState,
	reducers: {
		setEmbedAlternateChrome(state, action: PayloadAction<boolean>) {
			state.embedAlternateChrome = action.payload;
		},
		clearEmbedAlternateChrome(state) {
			state.embedAlternateChrome = false;
			state.postLoginPath = null;
		},
		setPostLoginRedirect(state, action: PayloadAction<string>) {
			state.postLoginPath = action.payload;
		},
		clearPostLoginRedirect(state) {
			state.postLoginPath = null;
		},
	},
});

export const {
	setEmbedAlternateChrome,
	clearEmbedAlternateChrome,
	setPostLoginRedirect,
	clearPostLoginRedirect,
} = externalPortalSlice.actions;
export default externalPortalSlice.reducer;
